import _ from 'lodash';

export default () => _.capitalize;




// WEBPACK FOOTER //
// ./src/filters/capitalize.js